__turbopack_context__.v({
  "attribution": "StaffQuote-module-scss-module__pD6UYG__attribution",
  "desktopPanel": "StaffQuote-module-scss-module__pD6UYG__desktopPanel",
  "figure": "StaffQuote-module-scss-module__pD6UYG__figure",
  "mobileAnchor": "StaffQuote-module-scss-module__pD6UYG__mobileAnchor",
  "mobileCard": "StaffQuote-module-scss-module__pD6UYG__mobileCard",
  "mobileTrigger": "StaffQuote-module-scss-module__pD6UYG__mobileTrigger",
  "mobileTriggerLabel": "StaffQuote-module-scss-module__pD6UYG__mobileTriggerLabel",
  "mobileTriggerPeeking": "StaffQuote-module-scss-module__pD6UYG__mobileTriggerPeeking",
  "peakAvatar": "StaffQuote-module-scss-module__pD6UYG__peakAvatar",
  "peakIcon": "StaffQuote-module-scss-module__pD6UYG__peakIcon",
  "quote": "StaffQuote-module-scss-module__pD6UYG__quote",
});
